/* @flow */
import { CreateEventCostEducation as CreateEventEducationCopy } from
  'payments/constants/CopyConstants';
import EducationMediaObject from './EducationMediaObject.jsx';
import React from 'react';

import './styles/CreateEventCostEducation.scss';

export default class CreateEventCostEducation extends React.Component {
  render() {
    return (
      <div className="CreateEventCostEducation" {...this.props}>
        <EducationMediaObject
          image={require('assets/images/payments/Treasurer/signin-dollarsign.svg')}
          className="CreateEventCostEducation-education"
          title={CreateEventEducationCopy.title1}
          text={CreateEventEducationCopy.subheader1}
        />
        <EducationMediaObject
          image={require('assets/images/payments/Treasurer/signin-document.svg')}
          className="CreateEventCostEducation-education"
          title={CreateEventEducationCopy.title2}
          text={CreateEventEducationCopy.subheader2}
        />
        <EducationMediaObject
          className="CreateEventCostEducation-education"
          image={require('assets/images/payments/Treasurer/school-bank-education.svg')}
          title={CreateEventEducationCopy.title3}
          text={CreateEventEducationCopy.subheader3}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/payments/components/CreateEventCostEducation.jsx